(() => {
  const mobileQuery = window.matchMedia('(max-width: 767.98px)');

  function init(root) {
    if (root.dataset.headReady === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[data-size-tab]'));
    const items = Array.from(root.querySelectorAll('.comparison-item'));
    const cta = root.querySelector('[data-size-cta]');
    const status = root.querySelector('[data-head-status]');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const manualBlinks = new WeakMap();
    let activeSize = 'mini';

    function blinkNow() {
      if (reducedMotionQuery.matches) return;

      root.querySelectorAll('.eye').forEach((eye) => {
        const previousBlink = manualBlinks.get(eye);
        if (previousBlink) previousBlink.cancel();
        if (typeof eye.animate !== 'function') return;

        const blink = eye.animate(
          [
            { transform: 'scaleY(1)' },
            { transform: 'scaleY(.08)', offset: 0.42 },
            { transform: 'scaleY(1)' }
          ],
          { duration: 320, easing: 'ease-in-out' }
        );
        manualBlinks.set(eye, blink);
        blink.addEventListener('finish', () => {
          if (manualBlinks.get(eye) === blink) manualBlinks.delete(eye);
        }, { once: true });
      });
    }

    function blinkAfterUpdate() {
      window.requestAnimationFrame(blinkNow);
    }

    function syncPanels() {
      const isMobile = mobileQuery.matches;
      items.forEach((item) => {
        const isActive = item.dataset.size === activeSize;
        const matchingTab = tabs.find((tab) => tab.dataset.size === item.dataset.size);
        item.dataset.active = String(isActive);
        if (isMobile) {
          item.setAttribute('role', 'tabpanel');
          item.setAttribute('aria-labelledby', matchingTab.id);
          item.setAttribute('aria-hidden', String(!isActive));
        } else {
          item.removeAttribute('role');
          item.removeAttribute('aria-labelledby');
          item.removeAttribute('aria-hidden');
        }
      });
    }

    function selectSize(size, focusTab = false) {
      const selected = tabs.find((tab) => tab.dataset.size === size);
      if (!selected) return;
      activeSize = size;
      tabs.forEach((tab) => {
        const isSelected = tab === selected;
        tab.setAttribute('aria-selected', String(isSelected));
        tab.tabIndex = isSelected ? 0 : -1;
      });
      syncPanels();
      if (cta) {
        cta.href = selected.dataset.url;
        cta.textContent = `Shop ${selected.querySelector('span').textContent} pillows`;
      }
      if (focusTab) selected.focus();
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        selectSize(tab.dataset.size);
        blinkAfterUpdate();
      });
      tab.addEventListener('keydown', (event) => {
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;
        event.preventDefault();
        selectSize(tabs[nextIndex].dataset.size, true);
        blinkAfterUpdate();
      });
    });

    root.querySelectorAll('input[data-example-age]').forEach((input) => {
      input.addEventListener('click', blinkAfterUpdate);
      input.addEventListener('change', () => {
        const width = Number(input.dataset.breadth);
        const height = Number(input.dataset.height);
        root.querySelectorAll('.head').forEach((head) => {
          head.setAttribute('width', width);
          head.setAttribute('height', height);
          head.setAttribute('x', 45 - width / 2);
          head.setAttribute('y', 29 - height / 2);
        });
        if (status) status.textContent = `Showing the same illustrative ${input.value}-year-old head on every size.`;
      });
    });

    root.querySelector('[data-size-tabs]').hidden = false;
    if (cta) cta.hidden = false;
    root.dataset.headReady = 'true';
    syncPanels();

    const reveal = () => root.classList.add('is-visible');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          reveal();
          observer.disconnect();
        }
      }, { threshold: 0.15 });
      observer.observe(root);
    } else reveal();

    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncPanels);
    else mobileQuery.addListener(syncPanels);
  }

  function scan(scope) {
    scope.querySelectorAll('.lp-head-comparison').forEach(init);
  }

  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
